import { cn } from '@/shared/lib/cn';
import './contact.scss';

type Props = {
    className?: string;
};
export const ContactNotSeenAvatar = ({ className }: Props) => {
    return (
        <div className={cn('contact__not-seen-avatar', className)}>
            <div />
            <div />
            <div />
        </div>
    );
};
